export const name_list = ["FINNS FITNESS CENTRE DAY PASS (6AM-9PM)", "FINNS FITNESS CENTRE OFF PEAK PASS (5PM-9PM)"]